var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNitroClawLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 5.33333,
  fill: "url(#paint0_linear_1657_15104)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.62683 4.17239C4.83593 4.17125 4.05396 4.33946 3.3335 4.66572L5.62683 9.69239L3.3335 14.7191C4.59226 15.2894 6.01837 15.3702 7.3335 14.9457L9.73016 9.69239L7.3335 4.43905C6.78223 4.26072 6.20622 4.17072 5.62683 4.17239Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9668 4.44L16.3635 9.69334L13.9668 14.9467C12.6517 15.3711 11.2256 15.2903 9.9668 14.72L12.2668 9.69334L9.9768 4.66667C11.2356 4.09635 12.6617 4.01553 13.9768 4.44H13.9668Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1657_15104",
  x1: 0.333333,
  y1: 0.666667,
  x2: 20,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A4FF94"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.216346,
  stopColor: "#94E5FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.384615,
  stopColor: "#4A88FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.586538,
  stopColor: "#774CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.788462,
  stopColor: "#FF5DC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF965D"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNitroClawLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nitro-claw-logo.ab66a66a7bccbd04b81d3a3fc8802422.svg";